import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SendAchMailAction} from '../../achRejectModule/components/ach-reject-list/send-ach-mail.action';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AppConstants} from '../../shared/constants/app-constants';

@Component({
    selector: 'app-ach-reject-pay-due-dialog',
    templateUrl: './ach-reject-pay-due-dialog.component.html',
    styleUrls: ['./ach-reject-pay-due-dialog.component.css'],
    standalone: false
})
export class AchRejectPayDueDialogComponent extends SendAchMailAction implements OnInit {

  _sendAchMailUrl: string;
  selectedItems = new Set<string>();
  _sendMailUrl = '/ach-rejects/pay-due/';
  constructor(private dialog: MatDialogRef<AchRejectPayDueDialogComponent>,
              dataManager: DataManagerService,
              snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: { total_due: number, selectedItems: any[] ,  account_id: string}) {
    super();
    this.snackBar = snackBar;
    this._sendAchMailUrl = AppConstants.BASE_URL + this._sendMailUrl + data.account_id;
    this.dataManager = dataManager;
    this.selectedItems = new Set<string>(data.selectedItems);
  }

  ngOnInit(): void {
  }

  closeAction() {
      this.dialog.close('cancel');
  }

  payDue() {
    const data = {
      selected_items: Array.from(this.selectedItems),
      total_due: this.data.total_due
    };
    this.sendAchMail(data);
  }
  protected passSendAchMailError(err) {
    this.showSnackBar(err.response, 'Ok', 5000);
    this.dialog.close(true);
  }

  protected passSendAchMailResponse(res) {
    this.showSnackBar(res.response, 'Ok', 5000);
    this.dialog.close('run');
  }
}
